var map = {
	"./act": 1452,
	"./act.ts": 1452,
	"./gmat": 1453,
	"./gmat.ts": 1453,
	"./gre": 1454,
	"./gre.ts": 1454,
	"./ielts": 1455,
	"./ielts.ts": 1455,
	"./ielts_general_training": 1456,
	"./ielts_general_training.ts": 1456,
	"./lsat": 1457,
	"./lsat.ts": 1457,
	"./mcat": 1458,
	"./mcat.ts": 1458,
	"./sat": 1459,
	"./sat.ts": 1459,
	"./toefl": 1460,
	"./toefl.ts": 1460
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2488;
module.exports = webpackAsyncContext;